<!--support MODAL-->
<div id="supportModal" class="modal fade" role="dialog">
    <div class="modal-dialog" role="document" style=" max-width: 380px; margin: 0 auto;">
        <div class="modal-content" style="min-height:430px">
            <div class="modal-header">
                <button type="button" class="close" aria-label="Close" data-dismiss="modal">
                    <span style="font-size: 22px; position: relative; top: -5px;" aria-hidden="true">&times;</span>
                </button>

            </div>

            <div class="modal-body text-center" style="padding-bottom: 25px;">

                <h4 style="font-size: 26px; margin-top: 0; font-weight: 400; ">We are happy to help!</h4>
                <br />

                <div>
                    <a href="https://form.asana.com/?k=U9HhqkxH0PAUX-1tF5KTmg&d=37813189344702"
                       tabindex="1"
                       class="btn-primary" style="padding:8px; border-radius:3px; margin-bottom:15px;"
                       aria-label="Press spacebar to submit an urgent request" target="_blank">Submit an urgent ticket</a>
                </div>
                <br />
                <br />

                <p style=" font-size: 20px; margin:0px;">Or if you prefer</p>
                <p style=" margin-bottom: 25px; font-size: 20px;">Give us a call</p>

                <p style=" margin-top: 0; font-weight: 500; ">Assessment Support Phone Line</p>
                <p>
                    <i style=" font-size: 30px; color: #0068bf; margin-right: 10px;" class="fa fa-phone" aria-hidden="true"></i>
                    <b><a style="color: black; cursor: pointer; font-size: 25px;" href="tel:(888)5894606">(888) 589-4606</a></b>
                </p>

                <br />
                <p style=" margin-top: 0; font-weight: 500; ">Hours of Operation</p>
                <p>
                    9am - 12pm, 2pm - 5pm, EST, Monday - Friday
                </p>

            </div>

        </div>
    </div>
</div>
<!--support MODAL end-->

<div class="leftMenu-backdrop" (click)="closeSidebarMenu($event)">
</div>
<div class="sidebar-wrapper">
    <div class="logo" [ngStyle]="{'height' : isBetaEnvironment ? '87px' : 'unset' }">
        <div class="simple-text">
            <div *ngIf="isBetaEnvironment" style="margin-top: 52px; margin-left: 45px; font-size: 30px;">
                BETA
            </div>

            <!--[routerLink]="['/niches']"-->
            <div class="logo-img">
                <!--<img src="/assets/img/angular2-logo-white.png" />-->
                <img aria-hidden="false" src="/assets/img/logo_eli_white.png" />
            </div>

            <i class="material-icons closeMenu" (click)="closeSidebarMenu($event)">arrow_back</i>
            <!--<span *ngIf="!myGlobals.rater">ELI</span>
            <span *ngIf="myGlobals.rater">ELI 360</span>-->
        </div>

    </div>
    <!--{{ 'ANNOUNCEMENTS.BTN_TEXT' | translate }}-->

    <ul class="nav responsive-nav">
        <!--<li *ngIf="isMobileMenu()">
            <a class="dropdown-toggle" data-toggle="dropdown">
                <i class="fa fa-dashboard"></i>
                <p class="hidden-lg hidden-md">Dashboard</p>
            </a>
        </li>-->
        <!--<li class="dropdown" *ngIf="isMobileMenu()">
              <a class="dropdown-toggle" data-toggle="dropdown">
                    <i class="fa fa-globe"></i>
                    <b class="caret hidden-sm hidden-xs"></b>
                    <span class="notification hidden-sm hidden-xs">5</span>
                    <p class="hidden-lg hidden-md">5 Notifications<b class="caret"></b></p>
              </a>
              <ul class="dropdown-menu">
                <li><a href="#">Notification 1</a></li>
                <li><a href="#">Notification 2</a></li>
                <li><a href="#">Notification 3</a></li>
                <li><a href="#">Notification 4</a></li>
                <li><a href="#">Another notification</a></li>
              </ul>
        </li>-->
        <!--<li *ngIf="isMobileMenu()">
           <a>
                <i class="fa fa-search"></i>
                <p class="hidden-lg hidden-md">Search</p>
            </a>
        </li>-->
        <!--<li *ngIf="isMobileMenu()">
           <a href="">
               <p>Account</p>
            </a>
        </li>-->
        <!--<li class="dropdown" *ngIf="isMobileMenu()">
              <a class="dropdown-toggle" data-toggle="dropdown">
                    <p>
                        Dropdown
                        <b class="caret"></b>
                    </p>

              </a>
              <ul class="dropdown-menu">
                <li><a href="#">Action</a></li>
                <li><a href="#">Another action</a></li>
                <li><a href="#">Something</a></li>
                <li><a href="#">Another action</a></li>
                <li><a href="#">Something</a></li>
                <li class="divider"></li>
                <li><a href="#">Separated link</a></li>
              </ul>
        </li>-->


        <ng-container *ngIf="myGlobals.getMode() == 'Administrator'">
            <li *ngFor="let menuItem of administratorMenuItems; let i = index;" class="info {{menuItem.class}}" [ngClass]="{'active': routeActive == menuItem[0].path}">
                <ng-container *ngIf="showMenuItemByUserType(menuItem[0].path)">
                    <!--//menuItem[0].path != 'notdefinied' &&-->
                    <!--<ng-container *ngIf="menuItem[0].path != 'assessments_mod_lll'; else modlll">-->
                    <a [routerLink]="[menuItem[0].path]" href="#collapse{{i}}" class="collapsed" (click)="closeSidebarMenu($event)">
                        <i class="{{menuItem[0].icon}}"></i>
                        <span>{{menuItem[0].menuTitle}}</span>
                    </a>
                    <!--</ng-container>-->
                    <!--<ng-template #modlll>
                        <ng-container *ngIf="myGlobals.userHasSpecificMode('Administrator')">
                            <a [routerLink]="[menuItem[0].path]" href="#collapse{{i}}" class="collapsed" (click)="closeSidebarMenu($event)">
                                <i class="{{menuItem[0].icon}}"></i>
                                <span>{{menuItem[0].menuTitle}}</span>
                            </a>
                        </ng-container>
                    </ng-template>-->

                </ng-container>

                <ng-container *ngIf="menuItem[0].path == 'notdefinied'">
                    <a data-toggle="collapse" href="#collapse{{i}}" class="collapsed">
                        <i class="{{menuItem[0].icon}}"></i>
                        <span>{{menuItem[0].menuTitle}}<b class="caret"></b></span>
                    </a>
                </ng-container>

                <div class="collapse" id="collapse{{i}}">
                    <ul class="nav">
                        <li routerLinkActive="active" *ngFor="let item of menuItem | slice:1; let j = index;" class="{{item.class}}">
                            <a [routerLink]="[item.path]" (click)="closeSidebarMenu($event)">
                                <i class="{{item.icon}}"></i>
                                <p>{{item.menuTitle}}</p>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
        </ng-container>

        <ng-container *ngIf="myGlobals.getMode() == 'Coach'">
            <li *ngFor="let menuItem of coachesMenuItems; let i = index;" class="info {{menuItem.class}}" [ngClass]="{'active': routeActive == menuItem[0].path}">

                <ng-container *ngIf="menuItem[0].path != 'notdefinied'">
                    <a [routerLink]="[menuItem[0].path]" href="#collapse{{i}}" class="collapsed" (click)="closeSidebarMenu($event)">
                        <i class="{{menuItem[0].icon}}"></i>
                        <span>{{menuItem[0].menuTitle}}</span>
                    </a>
                </ng-container>

                <ng-container *ngIf="menuItem[0].path == 'notdefinied'">
                    <a data-toggle="collapse" href="#collapse{{i}}" class="collapsed">
                        <i class="{{menuItem[0].icon}}"></i>
                        <span>{{menuItem[0].menuTitle}}<b class="caret"></b></span>
                    </a>
                </ng-container>

                <div class="collapse" id="collapse{{i}}">
                    <ul class="nav">
                        <li *ngFor="let item of menuItem | slice:1; let j = index;" class="{{item.class}}">
                            <a [routerLink]="[item.path]" (click)="closeSidebarMenu($event)">
                                <i class="{{item.icon}}"></i>
                                <p>{{item.menuTitle}}</p>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>

            <li class="support" style="cursor: pointer;">
                <a href="https://go.ipeccoaching.com/eli-toolkit" target="_blank">
                    <i class="pe-7s-box1"></i>
                    <span>ELI Toolkit</span>
                </a>
            </li>

            <li style="cursor: pointer;">
                <a href="https://helpcenter.ipec.com/assessments" target="_blank">
                    <i class="pe-7s-help1"></i>
                    <span>Help Center</span>
                </a>
            </li>

            <li style="cursor: pointer;">
                <a (click)="getSupport()">
                    <i class="pe-7s-call"></i>
                    <span>Urgent Support</span>
                </a>
            </li>

            <!--<li>
        <div class="urgentRequest">
            <a href="https://form.asana.com/?k=U9HhqkxH0PAUX-1tF5KTmg&d=37813189344702" tabindex="1" aria-label="Press spacebar to submit an urgent request" target="_blank">Click here to submit an urgent request</a>
        </div>
    </li>-->
            <!--<li>
        <div class="appVersion">
            <span>v myGlobals.getVersion()</span>
        </div>
    </li>-->
        </ng-container>

        <ng-container *ngIf="myGlobals.getMode() == 'Client'">
            <li *ngFor="let menuItem of clientsMenuItems; let i = index;" class="info {{menuItem.class}}" [ngClass]="{'active': routeActive == menuItem[0].path}">

                <ng-container *ngIf="menuItem[0].path != 'notdefinied'">
                    <a [routerLink]="[menuItem[0].path]" href="#collapse{{i}}" class="collapsed" (click)="closeSidebarMenu($event)">
                        <i class="{{menuItem[0].icon}}"></i>
                        <span>{{menuItem[0].menuTitle}}</span>
                    </a>
                </ng-container>

                <ng-container *ngIf="menuItem[0].path == 'notdefinied'">
                    <a data-toggle="collapse" href="#collapse{{i}}" class="collapsed">
                        <i class="{{menuItem[0].icon}}"></i>
                        <span>{{menuItem[0].menuTitle}}<b class="caret"></b></span>
                    </a>
                </ng-container>

                <div class="collapse" id="collapse{{i}}">
                    <ul class="nav">
                        <li routerLinkActive="active" *ngFor="let item of menuItem | slice:1; let j = index;" class="{{item.class}}">
                            <a [routerLink]="[item.path]" (click)="closeSidebarMenu($event)">
                                <i class="{{item.icon}}"></i>
                                <p>{{item.menuTitle}}</p>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
        </ng-container>

        <ng-container *ngIf="myGlobals.getMode() == 'Rater'">
            <li *ngFor="let menuItem of raterMenuItems; let i = index;" class="info {{menuItem.class}}" [ngClass]="{'active': routeActive == menuItem[0].path}">

                <ng-container *ngIf="menuItem[0].path != 'notdefinied'">
                    <a [routerLink]="[menuItem[0].path]" href="#collapse{{i}}" class="collapsed" (click)="closeSidebarMenu($event)">
                        <i class="{{menuItem[0].icon}}"></i>
                        <span>{{menuItem[0].menuTitle}}</span>
                    </a>
                </ng-container>

                <ng-container *ngIf="menuItem[0].path == 'notdefinied'">
                    <a data-toggle="collapse" href="#collapse{{i}}" class="collapsed">
                        <i class="{{menuItem[0].icon}}"></i>
                        <span>{{menuItem[0].menuTitle}}<b class="caret"></b></span>
                    </a>
                </ng-container>

                <div class="collapse" id="collapse{{i}}">
                    <ul class="nav">
                        <li routerLinkActive="active" *ngFor="let item of menuItem | slice:1; let j = index;" class="{{item.class}}">
                            <a [routerLink]="[item.path]" (click)="closeSidebarMenu($event)">
                                <i class="{{item.icon}}"></i>
                                <p>{{item.menuTitle}}</p>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
        </ng-container>

        <!--<ng-container *ngIf="myGlobals.getMode() == 'Rater'">
            <li *ngFor="let menuItem of ratersMenuItems; let i = index;" class="info {{menuItem.class}}">

                <a data-toggle="collapse" href="#collapse{{i}}" class="collapsed">
                    <i class="{{menuItem[0].icon}}"></i>
                    <span>{{menuItem[0].menuTitle}}<b class="caret"></b></span>
                </a>

                <div class="collapse" id="collapse{{i}}">
                    <ul class="nav">
                        <li routerLinkActive="active" *ngFor="let item of menuItem | slice:1; let j = index;" class="{{item.class}}">
                            <a [routerLink]="[item.path]">
                                <i class="{{item.icon}}"></i>
                                <p>{{item.menuTitle}}</p>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
        </ng-container>

        <ng-container *ngIf="myGlobals.rater">
            <li routerLinkActive="active" *ngFor="let raterMenuItem of ratersMenuItems" class="{{raterMenuItem.class}}">
                <a [routerLink]="[raterMenuItem.path]">
                    <i class="{{raterMenuItem.icon}}"></i>
                    <p>{{raterMenuItem.menuTitle}}</p>
                </a>
            </li>
        </ng-container>-->
        <!--<ng-container *ngIf="myGlobals.admin">
            <li routerLinkActive="active" *ngFor="let menuItem of menuItems" class="{{menuItem.class}}">
                <a [routerLink]="[menuItem.path]">
                    <i class="{{menuItem.icon}}"></i>
                    <p>{{menuItem.menuTitle}}</p>
                </a>
            </li>
        </ng-container>-->
        <!--<ng-container *ngIf="myGlobals.coach">
            <li routerLinkActive="active" *ngFor="let coachMenuItem of coachesMenuItems" class="{{coachMenuItem.class}}">
                <a [routerLink]="[coachMenuItem.path]">
                    <i class="{{coachMenuItem.icon}}"></i>
                    <p>{{coachMenuItem.menuTitle}}</p>
                </a>
            </li>
        </ng-container>-->
        <!--<ng-container *ngIf="myGlobals.client">
            <li routerLinkActive="active" *ngFor="let clientMenuItem of clientsMenuItems" class="{{clientMenuItem.class}}">
                <a [routerLink]="[clientMenuItem.path]">
                    <i class="{{clientMenuItem.icon}}"></i>
                    <p>{{clientMenuItem.menuTitle}}</p>
                </a>
            </li>
        </ng-container>-->
        <!--<li>
           <a [routerLink]="[help]">
               <i class="pe-7s-search"></i>
               <p>Help</p>
            </a>
        </li>-->
        <!--<li class="separator hidden-lg hidden-md" *ngIf="isMobileMenu()"></li>-->
        <!--<li *ngIf="isMobileMenu()">
            <a>
                <i class="large material-icons">call_missed_outgoing</i>
                <p>Log out</p>
            </a>
        </li>-->

    </ul>
</div>